import moment from "moment";
import { convertToPercent, deepCopy, getAppData, getDatesInRange, getDayDateKey, getFromState, getObjectFilter, getPermissions, getTransformedSegments, round, setUpDate } from "../../../app/util";
import { useDataSummary } from "../../Tile/kpiService";
import dataService from "../../../services/data.service";
import { useSelector } from "react-redux";
import { transformSegmentData } from "../segmentedData";
import { getSegmentedCode } from "../processDataReports";
import { getSegmentKeyTotal, getSegmentKeyTotal_new, getTopSegments } from "./pace_report_functions";

export function getReportData_otbMultiSegment(inputData, columns, auth, app_state, ui_state) {
    const { active_tiles, table_filters } = ui_state;
    const { dayDate } = app_state.workspace_controls;
    const useVarCapacity = !!(ui_state.showVariableCapacity);
    let filteredSegment = [];
    let data = deepCopy(inputData);
    let fullData = deepCopy(dataService.getSeriesById("OSR").data.data);
    let setup_data = [];
    if (data) {
        let dataKey = "HotelTotal";
        data.map((item, index) => {
            console.log(" ==> ",item[dataKey]);
            let segmentDateData = fullData.filter((x) => x.index.date === item.index.date)
            const ht = segmentDateData[0]?.HotelTotal;
            const vcapByKey = {
                primary:      (useVarCapacity && ht?.primary?.VCapacity)      || ht?.primary?.Capacity      || null,
                sdly:         (useVarCapacity && ht?.sdly?.VCapacity)         || ht?.sdly?.Capacity         || null,
                sdtly:        (useVarCapacity && ht?.sdtly?.VCapacity)        || ht?.sdtly?.Capacity        || null,
                sdly_actual:  (useVarCapacity && ht?.sdly_actual?.VCapacity)  || ht?.sdly_actual?.Capacity  || null,
                sdtly_actual: (useVarCapacity && ht?.sdtly_actual?.VCapacity) || ht?.sdtly_actual?.Capacity || null,
            };
            let data_columns = [];
            columns.map(col => {
                let dataObj = {};
                if (col.type === 'dateColumn') {
                    dataObj = setUpDate(dataObj, item.index.date);
                    if (app_state.workspace_controls.segmented_view) {
                        dataObj["segment"] = item.index.segment;
                    }
                }
                if (col.type === 'dataColumn') {
                    let { mainKey } = col;
                    col.subcolumns.map(key => {

                        if (mainKey === "difference_sdly") {
                            let dayDateKey = (dayDate === "day") ? "sdly" : "sdtly";
                            if (key.value === "Occ") {
                                const primaryOcc = vcapByKey.primary ? item[dataKey]["primary"].Rooms / vcapByKey.primary : item[dataKey]["primary"][key.value];
                                const sdlyOcc = vcapByKey[dayDateKey] ? item[dataKey][dayDateKey].Rooms / vcapByKey[dayDateKey] : item[dataKey][dayDateKey][key.value];
                                dataObj[key.value] = convertToPercent(primaryOcc - sdlyOcc)
                            } else if (key.value === "RevPAR") {
                                const primaryRevPAR = vcapByKey.primary ? item[dataKey]["primary"].Revenue / vcapByKey.primary : item[dataKey]["primary"][key.value];
                                const sdlyRevPAR = vcapByKey[dayDateKey] ? item[dataKey][dayDateKey].Revenue / vcapByKey[dayDateKey] : item[dataKey][dayDateKey][key.value];
                                dataObj[key.value] = round(primaryRevPAR - sdlyRevPAR)
                            } else if (key.value === "Available") {
                                const avail1 = vcapByKey.primary ? round(vcapByKey.primary - item[dataKey]["primary"].Rooms) : null;
                                const avail2 = vcapByKey[dayDateKey] ? round(vcapByKey[dayDateKey] - item[dataKey][dayDateKey].Rooms) : null;
                                dataObj[key.value] = (avail1 !== null && avail2 !== null) ? round(avail1 - avail2) : 0;
                                if (vcapByKey.primary && vcapByKey[dayDateKey]) {
                                    // Segmented-view Total row gets rebuilt by summing segment rows
                                    // (TableReports.js getTotalData), which drops Available — this lets
                                    // that rebuild restore it, same mechanism the TY/LY columns use.
                                    dataObj._vcap = round(vcapByKey.primary - vcapByKey[dayDateKey]);
                                }
                            } else {
                                dataObj[key.value] = round(item[dataKey]["primary"][key.value] - item[dataKey][dayDateKey][key.value])
                            }
                        } else if (mainKey === "variance_sdly") {
                            let dayDateKey = (dayDate === "day") ? "sdly" : "sdtly";
                            let primaryVal, sdlyVal;
                            if (key.value === "Occ") {
                                primaryVal = vcapByKey.primary ? item[dataKey]["primary"].Rooms / vcapByKey.primary : item[dataKey]["primary"][key.value];
                                sdlyVal = vcapByKey[dayDateKey] ? item[dataKey][dayDateKey].Rooms / vcapByKey[dayDateKey] : item[dataKey][dayDateKey][key.value];
                            } else if (key.value === "RevPAR") {
                                primaryVal = vcapByKey.primary ? item[dataKey]["primary"].Revenue / vcapByKey.primary : item[dataKey]["primary"][key.value];
                                sdlyVal = vcapByKey[dayDateKey] ? item[dataKey][dayDateKey].Revenue / vcapByKey[dayDateKey] : item[dataKey][dayDateKey][key.value];
                            } else if (key.value === "Available") {
                                primaryVal = vcapByKey.primary ? round(vcapByKey.primary - item[dataKey]["primary"].Rooms) : 0;
                                sdlyVal = vcapByKey[dayDateKey] ? round(vcapByKey[dayDateKey] - item[dataKey][dayDateKey].Rooms) : 0;
                            } else {
                                primaryVal = item[dataKey]["primary"][key.value];
                                sdlyVal = item[dataKey][dayDateKey][key.value];
                            }
                            let varianceValue = (primaryVal - sdlyVal) / sdlyVal;
                            dataObj[key.value] = (varianceValue && isFinite(varianceValue)) ? convertToPercent(varianceValue) + "%" : 0 + "%";
                        }
                        else if (mainKey === "pickup_diff_sdly") {
                            let dayDateKey = (dayDate === "day") ? "sdly" : "sdtly";
                            let dayDate_sdly_actual = (dayDate === "day") ? "sdly_actual" : "sdtly_actual";

                            if (key.value == "Occ") {
                                dataObj[key.value] = convertToPercent(item[dataKey][dayDate_sdly_actual][key.value] - item[dataKey][dayDateKey][key.value])
                            } else if (key.value === "ADR") {
                                dataObj[key.value] = (item[dataKey][dayDate_sdly_actual]['Revenue'] - item[dataKey][dayDateKey]['Revenue']) / (item[dataKey][dayDate_sdly_actual]['Rooms'] - item[dataKey][dayDateKey]['Rooms']);
                            } else if (key.value === "Available") {
                                const avail1 = vcapByKey[dayDate_sdly_actual] ? round(vcapByKey[dayDate_sdly_actual] - item[dataKey][dayDate_sdly_actual].Rooms) : null;
                                const avail2 = vcapByKey[dayDateKey] ? round(vcapByKey[dayDateKey] - item[dataKey][dayDateKey].Rooms) : null;
                                dataObj[key.value] = (avail1 !== null && avail2 !== null) ? round(avail1 - avail2) : 0;
                                if (vcapByKey[dayDate_sdly_actual] && vcapByKey[dayDateKey]) {
                                    dataObj._vcap = round(vcapByKey[dayDate_sdly_actual] - vcapByKey[dayDateKey]);
                                }
                            } else {
                                dataObj[key.value] = round(item[dataKey][dayDate_sdly_actual][key.value] - item[dataKey][dayDateKey][key.value])
                            }
                        } else if (mainKey === "restrictions" && getAppData(auth, app_state).restrictions.enable) {
                            let resData = dataService.getSeriesById("GetRestrictions").data;
                            resData = resData && resData.cur ? resData.cur : [];
                            let filteredData = getObjectFilter(deepCopy(resData), item.index.date, "stay_date")
                            let filterRestData = [];
                            if (filteredData[0]) {
                                Object.keys(filteredData[0]).forEach(function (key) {
                                    if (filteredData[0][key] === false || filteredData[0][key] === 1) {
                                        delete filteredData[0][key];
                                    }
                                });
                                filterRestData.push(filteredData[0]);
                            }
                            dataObj[key.value] = filterRestData;
                        } else if (item[dataKey][mainKey]) {
                            mainKey = getDayDateKey(dayDate, mainKey);
                            if (key.value == "ADR") {
                                let adrVal = item[dataKey][mainKey]['Revenue'] / item[dataKey][mainKey]['Rooms'];
                                dataObj[key.value] = adrVal;
                            } else if (key.value == "Occ") {
                                const vcap = vcapByKey[mainKey];
                                const occVal = vcap
                                    ? item[dataKey][mainKey].Rooms / vcap
                                    : item[dataKey][mainKey][key.value];
                                dataObj[key.value] = convertToPercent(occVal);
                                const vCapVC_ht = ht?.[mainKey]?.VCapacity;
                                const vCap_ht = vCapVC_ht || ht?.[mainKey]?.Capacity;
                                if (vCap_ht) {
                                    dataObj._vcap = useVarCapacity ? vCap_ht : ht?.[mainKey]?.Capacity;
                                    dataObj._vcapLabel = (useVarCapacity && vCapVC_ht) ? 'Variable Capacity' : 'Capacity';
                                    dataObj._vcapDiffers = !!(vCapVC_ht && vCapVC_ht !== ht?.[mainKey]?.Capacity);
                                }
                            } else if (key.value === "Available") {
                                const vcap = vcapByKey[mainKey];
                                const rooms = item[dataKey]?.[mainKey]?.Rooms;
                                dataObj[key.value] = (vcap && rooms !== undefined) ? round(vcap - rooms) : 0;
                            } else {
                                const vcap = vcapByKey[mainKey];
                                const val = (vcap && key.value === "RevPAR")
                                    ? item[dataKey][mainKey].Revenue / vcap
                                    : item[dataKey][mainKey][key.value];
                                dataObj[key.value] = round(val);
                            }

                        }
                    })
                }
                dataObj.id = col.id;
                data_columns.push(dataObj);
            })

            data_columns.map((itmArr, idx) => {
                if (itmArr['date'] == "" || itmArr['segment'] === "Total") {
                    data_columns[idx]["ignore_sort"] = true;
                }
            })
            setup_data.push(data_columns);
        })
    }
    return setup_data;
}


// function to get Top Segment 
export function getOtbMultiSegmentReportSegmentedData_hotel(columns, auth, app_state, ui_state) {
    let dataSeg = deepCopy(dataService.getSeriesById("OSRSegment").data.data);
    const { active_tiles, table_filters } = ui_state;
    const { dayDate } = app_state.workspace_controls;
    const useVarCapacity = !!(
        ui_state.showVariableCapacity &&
        getPermissions(auth.profile.property_details, app_state.property_id).permissions?.variable_capacity_enabled
    );

    const osrData = dataService.getSeriesById("OSR")?.data?.data;
    const filteredDow = [];//table_filters.table_reports.dow.map(d => d.code);
    let data = dataSeg;
    let setup_data = [];
    let { date_from, date_until } = app_state.primary_stay_range;

    let dates = getDatesInRange(date_from, date_until);
    let categoryList = ["Transient", "Group", "Contract", "Total"];
    let blankObj = { Rooms: 0, Occ: 0, ADR: 0, RevPAR: 0, SellRate: 0, Revenue: 0 };
    let primaryTotal = { Rooms: 0, Occ: 0, ADR: 0, RevPAR: 0, SellRate: 0, Revenue: 0 };
    let sdlyTotal = { Rooms: 0, Occ: 0, ADR: 0, RevPAR: 0, SellRate: 0, Revenue: 0 };
    let sdly_actualTotal = { Rooms: 0, Occ: 0, ADR: 0, RevPAR: 0, SellRate: 0, Revenue: 0 };

    let allTotal = {
        "Transient": {
            "primary": blankObj,
            "sdly": blankObj,
            "sdly_actual": blankObj
        },
        "Group": {
            "primary": blankObj,
            "sdly": blankObj,
            "sdly_actual": blankObj
        },
        "Contract": {
            "primary": blankObj,
            "sdly": blankObj,
            "sdly_actual": blankObj
        },

    }

    let selectedCatSegmentCode = [];
    categoryList.map((category, categoryIndex) => {
        selectedCatSegmentCode = [...selectedCatSegmentCode, ...getTopSegments(auth, app_state, category)];
    })
    ///// end final total //// 
    if (dates && dates.length > 0) {
        dates.map((date, dateIndex) => {
            const osrItem = osrData?.find(x => moment(x.index.date).format("YYYY-MM-DD") === date);
            const oht = osrItem?.HotelTotal;
            const vcapByKey = {
                primary:      (useVarCapacity && oht?.primary?.VCapacity)      || oht?.primary?.Capacity      || null,
                sdly:         (useVarCapacity && oht?.sdly?.VCapacity)         || oht?.sdly?.Capacity         || null,
                sdtly:        (useVarCapacity && oht?.sdtly?.VCapacity)        || oht?.sdtly?.Capacity        || null,
                sdly_actual:  (useVarCapacity && oht?.sdly_actual?.VCapacity)  || oht?.sdly_actual?.Capacity  || null,
                sdtly_actual: (useVarCapacity && oht?.sdtly_actual?.VCapacity) || oht?.sdtly_actual?.Capacity || null,
            };
            categoryList.map((category, categoryIndex) => {
                let data_columns = [];
                let segmentCodes = getTopSegments(auth, app_state, category);
                let codes = (category === "Total") ? selectedCatSegmentCode : segmentCodes;

                columns.map(col => {
                    let dataObj = {};
                    dataObj.id = col.id;
                    if (col.type === 'dateColumn') {
                        dataObj = setUpDate(dataObj, date);
                        if (app_state.workspace_controls.segmented_view) {
                            dataObj["segment"] = category;
                        }
                    }
                    if (col.type === 'dataColumn') {
                        let { mainKey } = col;
                        col.subcolumns.map(key => {
                            if (mainKey === "difference_sdly") {
                                let dayDateKey = (dayDate === "day") ? "sdly" : "sdtly";
                                let keyPrimaryTotalValue = getSegmentKeyTotal(data[dateIndex], key.value, codes, "primary", "osr", category);
                                let keySdlyTotalValue = getSegmentKeyTotal(data[dateIndex], key.value, codes, dayDateKey, "osr", category);
                                if (key.value === "Occ") {
                                    const primaryOcc = vcapByKey.primary
                                        ? getSegmentKeyTotal(data[dateIndex], 'Rooms', codes, "primary", "osr", category) / vcapByKey.primary
                                        : keyPrimaryTotalValue;
                                    const sdlyOcc = vcapByKey[dayDateKey]
                                        ? getSegmentKeyTotal(data[dateIndex], 'Rooms', codes, dayDateKey, "osr", category) / vcapByKey[dayDateKey]
                                        : keySdlyTotalValue;
                                    dataObj[key.value] = convertToPercent(primaryOcc - sdlyOcc)
                                } else if (key.value === "RevPAR") {
                                    const primaryRevPAR = vcapByKey.primary
                                        ? getSegmentKeyTotal(data[dateIndex], 'Revenue', codes, "primary", "osr", category) / vcapByKey.primary
                                        : keyPrimaryTotalValue;
                                    const sdlyRevPAR = vcapByKey[dayDateKey]
                                        ? getSegmentKeyTotal(data[dateIndex], 'Revenue', codes, dayDateKey, "osr", category) / vcapByKey[dayDateKey]
                                        : keySdlyTotalValue;
                                    dataObj[key.value] = round(primaryRevPAR - sdlyRevPAR)
                                } else if (key.value === "Available") {
                                    if (category === 'Total') {
                                        const avail1 = vcapByKey.primary ? round(vcapByKey.primary - getSegmentKeyTotal(data[dateIndex], 'Rooms', codes, "primary", "osr", category)) : null;
                                        const avail2 = vcapByKey[dayDateKey] ? round(vcapByKey[dayDateKey] - getSegmentKeyTotal(data[dateIndex], 'Rooms', codes, dayDateKey, "osr", category)) : null;
                                        dataObj[key.value] = (avail1 !== null && avail2 !== null) ? round(avail1 - avail2) : 0;
                                        if (vcapByKey.primary && vcapByKey[dayDateKey]) {
                                            // The segmented-view Total row gets rebuilt by summing the
                                            // Transient/Group/Contract rows (see TableReports.js getTotalData),
                                            // which drops Available entirely. That rebuild restores it only
                                            // when `_vcap` is present, keying off the same mechanism the
                                            // TY/LY Available columns already rely on.
                                            dataObj._vcap = round(vcapByKey.primary - vcapByKey[dayDateKey]);
                                        }
                                    } else {
                                        dataObj[key.value] = 0;
                                    }
                                } else {
                                    dataObj[key.value] = round(keyPrimaryTotalValue - keySdlyTotalValue)
                                }
                            } else if (mainKey === "variance_sdly") {
                                let dayDateKey = (dayDate === "day") ? "sdly" : "sdtly";
                                let keyPrimaryTotalValue = getSegmentKeyTotal(data[dateIndex], key.value, codes, "primary", "osr", category);
                                let keySdlyTotalValue = getSegmentKeyTotal(data[dateIndex], key.value, codes, dayDateKey, "osr", category);
                                if (key.value === "Occ") {
                                    if (vcapByKey.primary) keyPrimaryTotalValue = getSegmentKeyTotal(data[dateIndex], 'Rooms', codes, "primary", "osr", category) / vcapByKey.primary;
                                    if (vcapByKey[dayDateKey]) keySdlyTotalValue = getSegmentKeyTotal(data[dateIndex], 'Rooms', codes, dayDateKey, "osr", category) / vcapByKey[dayDateKey];
                                } else if (key.value === "RevPAR") {
                                    if (vcapByKey.primary) keyPrimaryTotalValue = getSegmentKeyTotal(data[dateIndex], 'Revenue', codes, "primary", "osr", category) / vcapByKey.primary;
                                    if (vcapByKey[dayDateKey]) keySdlyTotalValue = getSegmentKeyTotal(data[dateIndex], 'Revenue', codes, dayDateKey, "osr", category) / vcapByKey[dayDateKey];
                                } else if (key.value === "Available") {
                                    if (category === 'Total') {
                                        keyPrimaryTotalValue = vcapByKey.primary ? round(vcapByKey.primary - getSegmentKeyTotal(data[dateIndex], 'Rooms', codes, "primary", "osr", category)) : 0;
                                        keySdlyTotalValue = vcapByKey[dayDateKey] ? round(vcapByKey[dayDateKey] - getSegmentKeyTotal(data[dateIndex], 'Rooms', codes, dayDateKey, "osr", category)) : 0;
                                    } else {
                                        keyPrimaryTotalValue = 0;
                                        keySdlyTotalValue = 0;
                                    }
                                }
                                let varianceValue = (keyPrimaryTotalValue - keySdlyTotalValue) / keySdlyTotalValue;
                                dataObj[key.value] = (varianceValue && isFinite(varianceValue)) ? convertToPercent(varianceValue) + "%" : 0 + "%";


                            } else if (mainKey === "pickup_diff_sdly") {
                                let dayDateKey = (dayDate === "day") ? "sdly" : "sdtly";
                                let dayDate_sdly_actual = (dayDate === "day") ? "sdly_actual" : "sdtly_actual";

                                let keySdlyActualTotalValue = getSegmentKeyTotal(data[dateIndex], key.value, codes, dayDate_sdly_actual, "osr", category);
                                let keySdlyTotalValue = getSegmentKeyTotal(data[dateIndex], key.value, codes, dayDateKey, "osr", category);
                                if (key.value === "ADR") {
                                    let revTotal = getSegmentKeyTotal(data[dateIndex], 'Revenue', codes, dayDate_sdly_actual, "osr", category) - getSegmentKeyTotal(data[dateIndex], 'Revenue', codes, dayDateKey, "osr", category);
                                    let roomsSATotal = getSegmentKeyTotal(data[dateIndex], 'Rooms', codes, dayDate_sdly_actual, "osr", category) - getSegmentKeyTotal(data[dateIndex], 'Rooms', codes, dayDateKey, "osr", category);
                                    dataObj[key.value] = revTotal / roomsSATotal;
                                } else if (key.value == "Occ") {
                                    dataObj[key.value] = convertToPercent(keySdlyActualTotalValue - keySdlyTotalValue);
                                } else if (key.value === "Available") {
                                    if (category === 'Total') {
                                        const avail1 = vcapByKey[dayDate_sdly_actual] ? round(vcapByKey[dayDate_sdly_actual] - getSegmentKeyTotal(data[dateIndex], 'Rooms', codes, dayDate_sdly_actual, "osr", category)) : null;
                                        const avail2 = vcapByKey[dayDateKey] ? round(vcapByKey[dayDateKey] - getSegmentKeyTotal(data[dateIndex], 'Rooms', codes, dayDateKey, "osr", category)) : null;
                                        dataObj[key.value] = (avail1 !== null && avail2 !== null) ? round(avail1 - avail2) : 0;
                                        if (vcapByKey[dayDate_sdly_actual] && vcapByKey[dayDateKey]) {
                                            // Same Total-row rebuild issue as difference_sdly above.
                                            dataObj._vcap = round(vcapByKey[dayDate_sdly_actual] - vcapByKey[dayDateKey]);
                                        }
                                    } else {
                                        dataObj[key.value] = 0;
                                    }
                                } else {
                                    dataObj[key.value] = round(keySdlyActualTotalValue - keySdlyTotalValue);
                                }
                            }
                            else {
                                mainKey = getDayDateKey(dayDate, mainKey);
                                let keyTotalValue = getSegmentKeyTotal(data[dateIndex], key.value, codes, mainKey, "osr", category);
                                const vcap = vcapByKey[mainKey];
                                if (key.value == "Occ") {
                                    if (vcap) {
                                        const totalRooms = getSegmentKeyTotal(data[dateIndex], 'Rooms', codes, mainKey, "osr", category);
                                        dataObj[key.value] = convertToPercent(totalRooms / vcap);
                                    } else {
                                        dataObj[key.value] = convertToPercent(keyTotalValue);
                                    }
                                    if (category === 'Total') {
                                        const htForVcap = oht || data[dateIndex]?.HotelTotal;
                                        const vCapVC = htForVcap?.[mainKey]?.VCapacity;
                                        const vCap = vCapVC || htForVcap?.[mainKey]?.Capacity;
                                        if (vCap) {
                                            dataObj._vcap = useVarCapacity ? vCap : htForVcap?.[mainKey]?.Capacity;
                                            dataObj._vcapLabel = (useVarCapacity && vCapVC) ? 'Variable Capacity' : 'Capacity';
                                            dataObj._vcapDiffers = !!(vCapVC && vCapVC !== htForVcap?.[mainKey]?.Capacity);
                                        }
                                    }
                                } else if (key.value === "Available") {
                                    if (category === 'Total' && vcap) {
                                        const totalRooms = getSegmentKeyTotal(data[dateIndex], 'Rooms', codes, mainKey, "osr", category);
                                        dataObj[key.value] = round(vcap - totalRooms);
                                    } else {
                                        dataObj[key.value] = 0;
                                    }
                                } else {
                                    if (key.value === "RevPAR" && vcap) {
                                        const totalRevenue = getSegmentKeyTotal(data[dateIndex], 'Revenue', codes, mainKey, "osr", category);
                                        dataObj[key.value] = round(totalRevenue / vcap);
                                    } else {
                                        dataObj[key.value] = round(keyTotalValue);
                                    }
                                    if (category !== "Total" && mainKey === "primary") {
                                        let fieldArr = Object.keys(primaryTotal);
                                        fieldArr.map((k) => {
                                            allTotal[category][mainKey][k] += round(keyTotalValue);
                                        })

                                    }
                                }
                            }
                        })
                    }
                    data_columns.push(dataObj);
                })
                setup_data.push(data_columns);
            })
        })
    }
    return setup_data;
}



export const getRoomClassCategory = (data) => {
    let classCategories = [];
    for (var k in data[0]) {
        if (k !== "index" && k !== "HotelTotal")
            classCategories.push(k);
    }
    return classCategories;
}

const getCodeOfClass = (category, data) => {
    let roomCode = [];
    for (var k in data[0][category]) {
        roomCode.push(k.replace("Segment_", ""));
    }
    return roomCode;
}

export function getOtbMultiSegmentReportSegmentedData_roomClass(columns, auth, app_state, ui_state) {
    let data = (dataService.getSeriesById("GetRoomClass").data) ? deepCopy(dataService.getSeriesById("GetRoomClass").data.data) : [];
    let setup_data = [];
    let { date_from, date_until } = app_state.primary_stay_range;

    const { active_tiles, table_filters } = ui_state;
    const { dayDate } = app_state.workspace_controls;
    const useVarCapacity = !!(
        ui_state.showVariableCapacity &&
        getPermissions(auth.profile.property_details, app_state.property_id).permissions?.variable_capacity_enabled
    );
    let dayDateKey = (dayDate === "day") ? "sdly" : "sdtly";
    let dayDate_sdly_actual = (dayDate === "day") ? "sdly_actual" : "sdtly_actual";
    let dates = getDatesInRange(date_from, date_until);

    if (data && data.length > 0) {
        let catList = getRoomClassCategory(data);

        let categoryList = [...catList, "Total"];
        /////// final Total /////
        let blankObj = { Rooms: 0, Occ: 0, ADR: 0, RevPAR: 0, SellRate: 0, Revenue: 0 };
        let primaryTotal = { Rooms: 0, Occ: 0, ADR: 0, RevPAR: 0, SellRate: 0, Revenue: 0 };
        let sdlyTotal = { Rooms: 0, Occ: 0, ADR: 0, RevPAR: 0, SellRate: 0, Revenue: 0 };
        let sdly_actualTotal = { Rooms: 0, Occ: 0, ADR: 0, RevPAR: 0, SellRate: 0, Revenue: 0 };
        let sdtlyTotal = { Rooms: 0, Occ: 0, ADR: 0, RevPAR: 0, SellRate: 0, Revenue: 0 };
        let sdtly_actualTotal = { Rooms: 0, Occ: 0, ADR: 0, RevPAR: 0, SellRate: 0, Revenue: 0 };

        let allTotal = {
            "roomclass_Deluxe": {
                "primary": blankObj,
                "sdly": blankObj,
                "sdtly": blankObj,
            }
        }
        categoryList.map((itm) => {
            let tmpObj = {
                [itm]: {
                    "primary": blankObj,
                    "sdly": blankObj,
                    "sdly_actual": blankObj,
                    "sdtly": blankObj,
                    "sdtly_actual": blankObj
                }
            }
        })
        allTotal["roomclass_Deluxe"]['primary']['Rooms'] = 333;
        ///// end final total //// 
        let allClassCodes = [];
        categoryList.map((category) => {
            allClassCodes = [...allClassCodes, ...getCodeOfClass(category, data)]
        })

        if (dates && dates.length > 0) {
            dates.map((date, dateIndex) => {
                const rcht = data[dateIndex]?.["HotelTotal"];
                const vcapByKey = {
                    primary:      (useVarCapacity && rcht?.primary?.VCapacity)      || rcht?.primary?.Capacity      || null,
                    sdly:         (useVarCapacity && rcht?.sdly?.VCapacity)         || rcht?.sdly?.Capacity         || null,
                    sdtly:        (useVarCapacity && rcht?.sdtly?.VCapacity)        || rcht?.sdtly?.Capacity        || null,
                    sdly_actual:  (useVarCapacity && rcht?.sdly_actual?.VCapacity)  || rcht?.sdly_actual?.Capacity  || null,
                    sdtly_actual: (useVarCapacity && rcht?.sdtly_actual?.VCapacity) || rcht?.sdtly_actual?.Capacity || null,
                };
                categoryList.map((category, categoryIndex) => {
                    let data_columns = [];
                    let segmentCodes = getCodeOfClass(category, data);
                    let codes = (category === 'Total') ? allClassCodes : segmentCodes;

                    // Per-class capacity (sum of this class's room types' VCapacityRt/Capacity) —
                    // used both for the indicator popover and, when the variable-capacity toggle
                    // is on, as the Occ%/RevPAR denominator for that class's TY/SDLY columns.
                    const classVcapByKey = {};
                    if (category !== 'Total') {
                        ['primary', 'sdly', 'sdtly', 'sdly_actual', 'sdtly_actual'].forEach((mk) => {
                            let vSum = 0, cSum = 0, anyV = false;
                            codes.forEach((code) => {
                                const seg = data[dateIndex][category]?.["Segment_" + code]?.[mk];
                                const segVCap = seg?.VCapacityRt;
                                const segCap = seg?.Capacity;
                                if (segVCap !== undefined && segVCap !== null) anyV = true;
                                vSum += (segVCap ?? segCap ?? 0);
                                cSum += (segCap ?? 0);
                            });
                            classVcapByKey[mk] = { vSum, cSum, anyV };
                        });
                    }
                    // Total row keeps hotel-wide vcapByKey as before. For an individual class row,
                    // use its own class capacity only when the toggle is on; when off, vcapByKey[mk]
                    // is {} (falsy) just like for Total, so this is identical to prior behavior.
                    const getVcapForKey = (mk) => (category === 'Total' || !useVarCapacity) ? vcapByKey[mk] : classVcapByKey[mk]?.vSum || classVcapByKey[mk]?.cSum;

                    columns.map(col => {
                        let dataObj = {};
                        dataObj.id = col.id;
                        if (col.type === 'dateColumn') {
                            dataObj = setUpDate(dataObj, date);
                            if (app_state.workspace_controls.segmented_view) {
                                dataObj["segment"] = category.replace("roomclass_", "");
                                // dataObj["segment"] = (categoryIndex == (categoryList.length - 1)) ? "Total" : category ;
                            }
                        }
                        if (col.type === 'dataColumn') {
                            let { mainKey } = col;
                            col.subcolumns.map(key => {
                                if (mainKey === "difference_sdly") {
                                    let keyPrimaryTotalValue = getSegmentKeyTotal_roomClass(data[dateIndex], key.value, codes, "primary", "osr", category, categoryList);
                                    let keySdlyTotalValue = getSegmentKeyTotal_roomClass(data[dateIndex], key.value, codes, dayDateKey, "osr", category, categoryList);

                                    if (key.value === "Occ") {
                                        const primaryOcc = getVcapForKey("primary")
                                            ? getSegmentKeyTotal_roomClass(data[dateIndex], 'Rooms', codes, "primary", "osr", category, categoryList) / getVcapForKey("primary")
                                            : keyPrimaryTotalValue;
                                        const sdlyOcc = getVcapForKey(dayDateKey)
                                            ? getSegmentKeyTotal_roomClass(data[dateIndex], 'Rooms', codes, dayDateKey, "osr", category, categoryList) / getVcapForKey(dayDateKey)
                                            : keySdlyTotalValue;
                                        dataObj[key.value] = convertToPercent(primaryOcc - sdlyOcc)
                                    } else if (key.value === "RevPAR") {
                                        const primaryRevPAR = getVcapForKey("primary")
                                            ? getSegmentKeyTotal_roomClass(data[dateIndex], 'Revenue', codes, "primary", "osr", category, categoryList) / getVcapForKey("primary")
                                            : keyPrimaryTotalValue;
                                        const sdlyRevPAR = getVcapForKey(dayDateKey)
                                            ? getSegmentKeyTotal_roomClass(data[dateIndex], 'Revenue', codes, dayDateKey, "osr", category, categoryList) / getVcapForKey(dayDateKey)
                                            : keySdlyTotalValue;
                                        dataObj[key.value] = round(primaryRevPAR - sdlyRevPAR)
                                    } else if (key.value === "Available") {
                                        const vcapP = getVcapForKey("primary");
                                        const vcapS = getVcapForKey(dayDateKey);
                                        const avail1 = vcapP ? round(vcapP - getSegmentKeyTotal_roomClass(data[dateIndex], 'Rooms', codes, "primary", "osr", category, categoryList)) : null;
                                        const avail2 = vcapS ? round(vcapS - getSegmentKeyTotal_roomClass(data[dateIndex], 'Rooms', codes, dayDateKey, "osr", category, categoryList)) : null;
                                        dataObj[key.value] = (avail1 !== null && avail2 !== null) ? round(avail1 - avail2) : 0;
                                        if (category === 'Total' && vcapP && vcapS) {
                                            // Segmented-view Total row gets rebuilt by summing the
                                            // individual class rows (TableReports.js getTotalData),
                                            // which drops Available — this restores it the same way
                                            // the TY/LY columns already do.
                                            dataObj._vcap = round(vcapP - vcapS);
                                        }
                                    } else {
                                        dataObj[key.value] = round(keyPrimaryTotalValue - keySdlyTotalValue)
                                    }
                                } else if (mainKey === "variance_sdly") {

                                    let keyPrimaryTotalValue = getSegmentKeyTotal_roomClass(data[dateIndex], key.value, codes, "primary", "osr", category, categoryList);
                                    let keySdlyTotalValue = getSegmentKeyTotal_roomClass(data[dateIndex], key.value, codes, dayDateKey, "osr", category, categoryList);
                                    if (key.value === "Occ") {
                                        if (vcapByKey.primary) keyPrimaryTotalValue = getSegmentKeyTotal_roomClass(data[dateIndex], 'Rooms', codes, "primary", "osr", category, categoryList) / vcapByKey.primary;
                                        if (vcapByKey[dayDateKey]) keySdlyTotalValue = getSegmentKeyTotal_roomClass(data[dateIndex], 'Rooms', codes, dayDateKey, "osr", category, categoryList) / vcapByKey[dayDateKey];
                                    } else if (key.value === "RevPAR") {
                                        if (vcapByKey.primary) keyPrimaryTotalValue = getSegmentKeyTotal_roomClass(data[dateIndex], 'Revenue', codes, "primary", "osr", category, categoryList) / vcapByKey.primary;
                                        if (vcapByKey[dayDateKey]) keySdlyTotalValue = getSegmentKeyTotal_roomClass(data[dateIndex], 'Revenue', codes, dayDateKey, "osr", category, categoryList) / vcapByKey[dayDateKey];
                                    } else if (key.value === "Available") {
                                        const vcapP = getVcapForKey("primary");
                                        const vcapS = getVcapForKey(dayDateKey);
                                        keyPrimaryTotalValue = vcapP ? round(vcapP - getSegmentKeyTotal_roomClass(data[dateIndex], 'Rooms', codes, "primary", "osr", category, categoryList)) : 0;
                                        keySdlyTotalValue = vcapS ? round(vcapS - getSegmentKeyTotal_roomClass(data[dateIndex], 'Rooms', codes, dayDateKey, "osr", category, categoryList)) : 0;
                                    }
                                    let varianceValue = (keyPrimaryTotalValue - keySdlyTotalValue) / keySdlyTotalValue;
                                    dataObj[key.value] = (varianceValue && isFinite(varianceValue)) ? convertToPercent(varianceValue) + "%" : 0 + "%";


                                } else if (mainKey === "pickup_diff_sdly") {
                                    let keySdlyActualTotalValue = getSegmentKeyTotal_roomClass(data[dateIndex], key.value, codes, dayDate_sdly_actual, "osr", category, categoryList);
                                    let keySdlyTotalValue = getSegmentKeyTotal_roomClass(data[dateIndex], key.value, codes, dayDateKey, "osr", category, categoryList);

                                    if (key.value === "ADR") {
                                        let revTotal = getSegmentKeyTotal_roomClass(data[dateIndex], 'Revenue', codes, dayDate_sdly_actual, "osr", category, categoryList) - getSegmentKeyTotal_roomClass(data[dateIndex], 'Revenue', codes, dayDateKey, "osr", category, categoryList);
                                        let roomsSATotal = getSegmentKeyTotal_roomClass(data[dateIndex], 'Rooms', codes, dayDate_sdly_actual, "osr", category, categoryList) - (getSegmentKeyTotal_roomClass(data[dateIndex], 'Rooms', codes, dayDateKey, "osr", category, categoryList));
                                        dataObj[key.value] = revTotal / roomsSATotal;
                                    } else if (key.value == "Occ") {
                                        dataObj[key.value] = convertToPercent(keySdlyActualTotalValue - keySdlyTotalValue)
                                    } else if (key.value === "Available") {
                                        const vcapSA = getVcapForKey(dayDate_sdly_actual);
                                        const vcapS = getVcapForKey(dayDateKey);
                                        const avail1 = vcapSA ? round(vcapSA - getSegmentKeyTotal_roomClass(data[dateIndex], 'Rooms', codes, dayDate_sdly_actual, "osr", category, categoryList)) : null;
                                        const avail2 = vcapS ? round(vcapS - getSegmentKeyTotal_roomClass(data[dateIndex], 'Rooms', codes, dayDateKey, "osr", category, categoryList)) : null;
                                        dataObj[key.value] = (avail1 !== null && avail2 !== null) ? round(avail1 - avail2) : 0;
                                        if (category === 'Total' && vcapSA && vcapS) {
                                            dataObj._vcap = round(vcapSA - vcapS);
                                        }
                                    } else {
                                        dataObj[key.value] = round(keySdlyActualTotalValue - keySdlyTotalValue)
                                    }


                                }
                                else {
                                    mainKey = getDayDateKey(dayDate, mainKey);
                                    let keyTotalValue = getSegmentKeyTotal_roomClass(data[dateIndex], key.value, codes, mainKey, "osr", category, categoryList);
                                    const vcap = getVcapForKey(mainKey);
                                    if (key.value == "Occ") {
                                        if (vcap) {
                                            const totalRooms = getSegmentKeyTotal_roomClass(data[dateIndex], 'Rooms', codes, mainKey, "osr", category, categoryList);
                                            dataObj[key.value] = convertToPercent(totalRooms / vcap);
                                        } else {
                                            dataObj[key.value] = convertToPercent(keyTotalValue);
                                        }
                                        if (category === 'Total') {
                                            const vCapVC = rcht?.[mainKey]?.VCapacity;
                                            const vCap = vCapVC || rcht?.[mainKey]?.Capacity;
                                            if (vCap) {
                                                dataObj._vcap = useVarCapacity ? vCap : rcht?.[mainKey]?.Capacity;
                                                dataObj._vcapLabel = (useVarCapacity && vCapVC) ? 'Variable Capacity' : 'Capacity';
                                                dataObj._vcapDiffers = !!(vCapVC && vCapVC !== rcht?.[mainKey]?.Capacity);
                                            }
                                        } else {
                                            const classCap = classVcapByKey[mainKey];
                                            if (classCap && (classCap.vSum || classCap.cSum)) {
                                                dataObj._rtVcap = classCap.vSum || classCap.cSum;
                                                dataObj._rtVcapLabel = classCap.anyV ? 'Variable Capacity' : 'Capacity';
                                                dataObj._rtVcapDiffers = !!(classCap.anyV && classCap.vSum !== classCap.cSum);
                                                dataObj._rtRoomTypes = codes;
                                            }
                                        }
                                    } else if (key.value === "Available") {
                                        const rtVcap = category === 'Total'
                                            ? vcap
                                            : (classVcapByKey[mainKey]?.vSum || classVcapByKey[mainKey]?.cSum);
                                        if (rtVcap) {
                                            const totalRooms = getSegmentKeyTotal_roomClass(data[dateIndex], 'Rooms', codes, mainKey, "osr", category, categoryList);
                                            dataObj[key.value] = round(rtVcap - totalRooms);
                                        } else {
                                            dataObj[key.value] = 0;
                                        }
                                    } else {
                                        if (key.value === "RevPAR" && vcap) {
                                            const totalRevenue = getSegmentKeyTotal_roomClass(data[dateIndex], 'Revenue', codes, mainKey, "osr", category, categoryList);
                                            dataObj[key.value] = round(totalRevenue / vcap);
                                        } else {
                                            dataObj[key.value] = round(keyTotalValue);
                                        }
                                        if (category !== "Total" && mainKey === "primary") {
                                            let fieldArr = Object.keys(primaryTotal);
                                            fieldArr.map((k) => {
                                            })

                                        }
                                        // debugger; will start from here
                                    }
                                }
                            })
                        }
                        data_columns.push(dataObj);
                    })
                    setup_data.push(data_columns);
                })

            })
        }
    }
    return setup_data;
}

export const getSegmentKeyTotal_roomClass = (item, key, segmentCodes, mainKey, segmentType = "osr", segmentTotalRow = "", selectedClass) => {
    let keyTotal = 0;
    let revenueTotal = 0;
    let roomsTotal = 0
    if (segmentTotalRow && segmentTotalRow === "Total") {
        // if (key !== "SellRate") {
        //     keyTotal = item["HotelTotal"][mainKey][key];
        // } else {
        //     keyTotal = 0;
        // }
        // return keyTotal;

        if (segmentCodes && segmentCodes.length > 0) {
            selectedClass.map((className) => {
                if (className !== 'Total') {
                    segmentCodes.map((code, index) => {
                        let segmentCode = (segmentType === "market") ? "MarketSegment_" + code : "Segment_" + code;
                        if (key === "ADR") {
                            revenueTotal += (item[className][segmentCode] && item[className][segmentCode][mainKey]["Revenue"]) ? item[className][segmentCode][mainKey]["Revenue"] : 0;
                            roomsTotal += (item[className][segmentCode] && item[className][segmentCode][mainKey]["Rooms"]) ? item[className][segmentCode][mainKey]["Rooms"] : 0;
                        } else {
                            keyTotal += (item[className][segmentCode] && item[className][segmentCode][mainKey][key]) ? item[className][segmentCode][mainKey][key] : 0;
                        }
                    })
                }
            })
            if (key === "ADR") {
                keyTotal = revenueTotal / roomsTotal;
            }
            return keyTotal;
        }
    } else {

        if (segmentCodes && segmentCodes.length > 0) {
            segmentCodes.map((code, index) => {
                let segmentCode = (segmentType === "market") ? "MarketSegment_" + code : "Segment_" + code;
                if (key === "ADR") {
                    revenueTotal += (item[segmentTotalRow][segmentCode][mainKey]["Revenue"]) ? item[segmentTotalRow][segmentCode][mainKey]["Revenue"] : 0;
                    roomsTotal += (item[segmentTotalRow][segmentCode][mainKey]["Rooms"]) ? item[segmentTotalRow][segmentCode][mainKey]["Rooms"] : 0;
                } else {
                    keyTotal += (item[segmentTotalRow][segmentCode][mainKey][key]) ? item[segmentTotalRow][segmentCode][mainKey][key] : 0;
                }
            })
            if (key === "ADR") {
                keyTotal = revenueTotal / roomsTotal;
            }
            return keyTotal;
        }

    }

}